import React from 'react';

import { DeleteIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import { useTranslation } from 'react-i18next';

import type { DeleteCardsProps } from '../types.point3';
import { useDeleteCardsWithConfirmationPoint3 } from './useDeleteCardsWithConfirmation.point3';

interface DeleteCardsButtonProps extends
  DeleteCardsProps,
  ButtonProps {}

function DeleteCardsButtonPoint3({
  cardIds,
  className = undefined,
  onDeleteCards = undefined,
  'data-testid': dataTestId = 'deletePersonButton',
  ...props
}: DeleteCardsButtonProps): React.JSX.Element {
  const { t } = useTranslation();
  const deleteCardsHandler = useDeleteCardsWithConfirmationPoint3({
    cardIds,
  });

  return (
    <Control.Button
      className={className}
      data-testid={dataTestId}
      icon={<DeleteIcon />}
      kind="negative"
      onClick={async () => {
        await deleteCardsHandler?.();
        onDeleteCards?.();
      }}
      size="medium"
      variant="flat"
      {...props}
    >
      {t('features:deletePerson.button')}
    </Control.Button>
  );
}

export { DeleteCardsButtonPoint3 };
